module.exports = "/_next/static/images/row3-1-f371d3232a5054af940aab52925ddc72.png";